const DOCK_ADDED_CONFIRM_MS = 3000;

let dockAddedRestoreTimer = null;

/**
 * @returns {NodeListOf<Element>}
 */
const getDockContextContainers = () =>
  document.querySelectorAll('.mobile-dock__product-actions, .header__context-actions--product');

/**
 * @param {Element | null | undefined} productFormEl
 * @returns {boolean}
 */
const isPdpProductForm = (productFormEl) => {
  if (!document.body.classList.contains('template-product')) {
    return false;
  }

  return Boolean(productFormEl?.closest('.product'));
};

/**
 * @param {Element | null | undefined} productFormEl
 * @returns {boolean}
 */
const isPdpUpsellQuickViewProductForm = (productFormEl) => {
  if (!document.body.classList.contains('template-product')) {
    return false;
  }

  const quickViewContent = document.getElementById('QuickViewContent');

  return Boolean(
    productFormEl?.closest('#QuickViewDock') && quickViewContent?.dataset.pdpUpsellQuickView === 'true',
  );
};

/**
 * @param {Element} container
 */
const hideDockAddedConfirmation = (container) => {
  const defaultEl = container.querySelector('.dock-context-default');
  const confirmationEl = container.querySelector('[data-dock-added-confirmation]');

  if (!defaultEl || !confirmationEl) {
    return;
  }

  defaultEl.hidden = false;
  confirmationEl.hidden = true;
  container.classList.remove('dock-added-confirmation-active');
};

const hideAllDockAddedConfirmations = () => {
  for (const container of getDockContextContainers()) {
    hideDockAddedConfirmation(container);
  }
};

/**
 * @param {{ title: string, imageSrc: string }} media
 */
const showDockAddedConfirmation = (media) => {
  const containers = getDockContextContainers();

  if (!containers.length) {
    return;
  }

  window.clearTimeout(dockAddedRestoreTimer);
  hideAllDockAddedConfirmations();

  for (const container of containers) {
    const defaultEl = container.querySelector('.dock-context-default');
    const confirmationEl = container.querySelector('[data-dock-added-confirmation]');

    if (!defaultEl || !confirmationEl) {
      continue;
    }

    const nameEl = confirmationEl.querySelector('.dock-added-confirmation__product-name');
    const imageEl = confirmationEl.querySelector('.dock-added-confirmation__image');

    if (nameEl) {
      nameEl.textContent = media.title;
    }

    if (imageEl && media.imageSrc) {
      imageEl.src = media.imageSrc;
      imageEl.alt = media.title;
    }

    defaultEl.hidden = true;
    confirmationEl.hidden = false;
    container.classList.add('dock-added-confirmation-active');
  }

  dockAddedRestoreTimer = window.setTimeout(() => {
    hideAllDockAddedConfirmations();
    dockAddedRestoreTimer = null;
  }, DOCK_ADDED_CONFIRM_MS);
};

const handlePdpAddedConfirmation = (media) => {
  if (!media?.title) {
    return;
  }

  showDockAddedConfirmation(media);
};

document.addEventListener('product-form:submit:success', (event) => {
  const productForm = event.target.closest('product-form');

  if (!productForm) {
    return;
  }

  const getMedia = window.getProductFlyMedia;

  if (typeof getMedia !== 'function') {
    return;
  }

  if (isPdpProductForm(productForm)) {
    handlePdpAddedConfirmation(getMedia(productForm));
    return;
  }

  if (isPdpUpsellQuickViewProductForm(productForm)) {
    handlePdpAddedConfirmation(getMedia(productForm));
  }
});

document.addEventListener('product-upsell:submit:success', (event) => {
  if (!document.body.classList.contains('template-product')) {
    return;
  }

  handlePdpAddedConfirmation(event.detail?.media);
});
